// AUTO-GENERATED by scripts/gen-squadron-colors.js — do not edit by hand.
// Dominant saturated color of each squadron patch; the SquadronPage hero
// fades from HVY blue to this accent. Re-run the script if patch art changes.
const SQUADRON_COLORS = {
  "472nd-f-16-viper": "#57084c",
  "484th-a-10-warthog": "#9e6a14",
  "584th-f-4-phantom": "#a68a71",
  "vmfa-390-f-18-hornet": "#719847",
  "142nd-assault-helicopter": "#454437",
  "vmgr-251-c-130-hercules": "#635339",
  "vfa-119-f-18-hornet": "#09618c",
  "vf-172-f-14-tomcat": "#c8a862",
  "blue-tide-demo-team": "#caa057",
  "23rd-aggressors-squadron": "#c13c26",
  "phantom-logistics": "#11567e"
};

module.exports = { SQUADRON_COLORS };
